import {NgModule} from '@angular/core';

import {LanguageSelectorComponent} from './language-selector/language-selector.component';
import {PsI18nModule} from '../../pf.core/i18n/psi18n.module';
import {CommonModule} from '@angular/common';
import {BsDropdownModule} from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    PsI18nModule,
    BsDropdownModule,
  ],
  declarations: [LanguageSelectorComponent],
  exports: [LanguageSelectorComponent]
})
export class I18nModule {}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/i18n/i18n.module.ts